import { AxiosRequestConfig } from "axios";

import { ApiError, AudienceBuild } from "@/types";
import { fetchData } from "@/utils";

type ValidateFileApiResponse = {
  data: { format: boolean; segment: boolean };
  error: ApiError | null;
};

export const validateFile = async (
  accessToken: string,
  file: File,
  upload_type: string,
): Promise<ValidateFileApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/upload/check?upload_type=${upload_type}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "text/csv",
    },
    data: file,
  };

  return fetchData(config);
};

type BuildUploadApiResponse = {
  data: AudienceBuild;
  error: ApiError | null;
};

export const buildUpload = async (
  accessToken: string,
  file: File,
  upload_type: string,
): Promise<BuildUploadApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/upload/build?upload_type=${upload_type}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "text/csv",
    },
    data: file,
  };

  return fetchData(config);
};

type UploadApiResponse = {
  data: { audience_id: string };
  error: ApiError | null;
};

export const upload = async (
  accessToken: string,
  file: File,
  upload_type: string,
): Promise<UploadApiResponse> => {
  let url = `${process.env.REACT_APP_API_URL}/upload?upload_type=${upload_type}`;

  const config: AxiosRequestConfig = {
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "text/csv",
    },
    data: file,
  };

  return fetchData(config);
};
